import { Container, Grid, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { FormApi } from 'final-form'
import { useEffect, useState, useRef } from 'react'
import { useQueryParam, StringParam } from 'use-query-params'
import SearchAccordion from '../control/accordion/SearchAccordion'
import useTranslate from '../i18n/useTranslate'
import {
    KeywordType,
    useSearchSettingConsideration,
    ConsiderationDataListType,
} from '../services/um/useSearchSettingConsideration'
import { useSettingConsideration } from '../services/um/useSettingConsideration'
import useLoadingStore from '../control/loading/store/useLoadingStore'
import useAuthenStore from '../stores/authen/authenStore'
import Panel from './../component/um/setting-consideration/Panel'
import Draggables from './../component/um/setting-consideration/Draggables'
import Dialog, { DialogType } from '../control/dialog/dialog'
export type ApproveStatusType = {
    approveStatus: ConsiderationDataListType[]
}

const SettingConsideration = () => {
    const translate = useTranslate()
    const loadingStore = useLoadingStore()
    const classes = useStyles()
    const authenStore = useAuthenStore()
    const { dataList, searchSettingConsideration } = useSearchSettingConsideration()
    const { putOrderSettingConsideration } = useSettingConsideration()
    const [recID, setRecID] = useQueryParam('recID', StringParam)
    const [submittedTypeID, setSubmittedTypeID] = useQueryParam('submittedTypeID', StringParam)
    const [isDragDisabled, setIsDragDisabled] = useState<boolean>(true)
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const [initialValues, setInitialValues] = useState({
        recID: (authenStore.profile.irb?.toString() || recID) ?? null,
        submittedTypeID: submittedTypeID ?? '1',
    })

    useEffect(() => {
        if (authenStore.profile.userId) {
            searchSettingConsideration(initialValues)
            setRecID(authenStore.profile.irb?.toString())
            setSubmittedTypeID(submittedTypeID ?? '1')
        }
    }, [authenStore.profile.userId])

    const onSubmit = async (value: KeywordType) => {
        const param = {
            recID: value.recID,
            submittedTypeID: value.submittedTypeID,
        }
        value.recID && setRecID(value.recID.toString())
        setSearchParam(value)
        searchSettingConsideration(param)
    }

    const setSearchParam = (value: KeywordType) => {
        setInitialValues(value)
        setSubmittedTypeID(value.submittedTypeID ? value.submittedTypeID.toString() : null)
    }

    const onReset = (form: FormApi<KeywordType, Partial<KeywordType>>) => {
        let param = {
            recID: recID || null,
            submittedTypeID: '1',
        }
        form.initialize(param)
        setInitialValues(param)
        searchSettingConsideration(param)
    }

    const handleOrderNumberMode = () => {
        setIsDragDisabled(!isDragDisabled)
        searchSettingConsideration({
            recID: recID || null,
            submittedTypeID: submittedTypeID || '1',
        })
    }

    const handleOrder = (value: ApproveStatusType) => {
        setConfigDialog({
            title: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.HEADER')}`,
            content: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.CONFIRM')}`,
            type: 'alert-confirm',
            onClickConfirm: () => onSave(value),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onSave = async (value: ApproveStatusType) => {
        let params = value.approveStatus.map((item) => item.approveStatusID)
        const result = await putOrderSettingConsideration(
            params,
            authenStore.profile.userId ?? 0,
            submittedTypeID ?? null,
            authenStore.profile.irb as number,
        )
        if (result.message === 'success') {
            setConfigDialog({
                title: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.SETTING_CONSIDERATION.MESSAGE.SUCCESS')}`,
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
            handleOrderNumberMode()
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    return (
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <Grid item xs={12}>
                    <SearchAccordion title={translate.get('UM.SETTING_CONSIDERATION.TITLE')}>
                        <Panel initialSearch={initialValues} onSubmit={onSubmit} onReset={onReset} />
                    </SearchAccordion>
                </Grid>

                <Grid item xs={12}>
                    <Draggables
                        handleOrderNumberMode={handleOrderNumberMode}
                        isDragDisabled={isDragDisabled}
                        handleOrder={handleOrder}
                        dataList={dataList}
                    />
                </Grid>

                {!loadingStore.isLoading && dataList?.length === 0 && (
                    <Grid
                        container
                        item
                        alignContent="center"
                        justify="center"
                        style={{ border: '1px solid rgba(0, 0, 0, .125)' }}
                    >
                        <Typography variant="h6">{translate.get('LABEL.NO_DATA_FOUND')}</Typography>
                    </Grid>
                )}
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    textResult: {
        margin: '8px 0',
    },
}))

export default SettingConsideration
